import { resetAlertsState } from "redux/reducers/alertsReducer";
import { initializePatients, resetPatientsState } from "redux/reducers/allPatientsReducer";
import { initializeProfessionals, resetProfessionalsState } from "redux/reducers/allProfessionalsReducer";
import { resetCaloriesState } from "redux/reducers/caloriesReducer";
import { resetFormsConfigState } from "redux/reducers/configFormsReducer";
import { resetContentState } from "redux/reducers/contentReducer";
import { resetHeartDataState } from "redux/reducers/heartDataReducer";
import { resetMessagesState } from "redux/reducers/messagesReducer";
import { resetNotesState } from "redux/reducers/notesReducer";
import { initializeOrganizations, resetOrganizationsState } from "redux/reducers/organizationsReducer";
import { initializeBusinessPackage, resetBusinessPackageState } from "redux/reducers/packagesReducer";
import { resetPatientContentState } from "redux/reducers/patientContentReducer";
import { resetFormsByPatient } from "redux/reducers/patientFormsReducer";
import { resetReportsByPatient } from "redux/reducers/patientReportReducer";
import { resetScoresByPatient } from "redux/reducers/patientScoreReducer";
import { resetScheduledFormState } from "redux/reducers/scheduledFormsReducer";
import { resetSelectedFormState } from "redux/reducers/selectedFormReducer";
import { resetSelectedPatientState } from "redux/reducers/selectedPatientReducer";
import { resetStepsState } from "redux/reducers/stepsReducer";
import { resetFormAnswersState } from "redux/reducers/studyFormAnswersExportsReducer";
import { resetAnswersState } from "redux/reducers/studyFormAnswersReducer";
import { resetStudyState } from "redux/reducers/studyReducer";
import { resetWeightState } from "redux/reducers/weightReducer";
import { RolesManager } from "utils/RolesManager";

// * Learn about redux middleware step by step: https://redux.js.org/introduction/learning-resources#middleware
export default function reduxMiddleware() {
  return (params) => (next) => (action) => {
    const { dispatch, getState } = params
    const { type, payload } = action

    switch (type) {
      case "selectedCenter/setSelectedCenter": {
        const user = getState()?.userAuthentication?.user

        const isAdmin = RolesManager.userIsAdmin(user.roles);
        const isProfessional = RolesManager.userIsProfessional(user.roles);
        const isSuperAdmin = RolesManager.userIsSuperAdmin(user.roles)

        dispatch(resetFormsConfigState())
        dispatch(resetProfessionalsState())
        dispatch(resetPatientsState())
        dispatch(resetStudyState())
        dispatch(resetAnswersState())
        dispatch(resetSelectedFormState())
        dispatch(resetContentState())
        dispatch(resetAlertsState())
        dispatch(resetFormAnswersState())
        dispatch(resetSelectedPatientState())
        dispatch(resetHeartDataState())
        dispatch(resetWeightState())
        dispatch(resetStepsState())
        dispatch(resetCaloriesState())
        dispatch(resetNotesState())
        dispatch(resetMessagesState())
        dispatch(resetPatientContentState())
        dispatch(resetFormsByPatient())
        dispatch(resetReportsByPatient())
        dispatch(resetScoresByPatient())
        dispatch(resetScheduledFormState())
        dispatch(resetBusinessPackageState())
        dispatch(resetOrganizationsState())

        if (isAdmin) {
          dispatch(initializeProfessionals(payload.id));
          dispatch(initializePatients(payload.id));
        }

        if (isSuperAdmin) {
          dispatch(initializeBusinessPackage(payload.id));
          dispatch(initializeOrganizations(payload.id))
        }


        if (isProfessional) {
          dispatch(initializePatients(payload.id));
        }

        break
      }
      case "selectedPatient/setSelectedPatient": {
        dispatch(resetFormsConfigState())
        dispatch(resetFormsByPatient())
        dispatch(resetHeartDataState())
        dispatch(resetWeightState())
        dispatch(resetStepsState())
        dispatch(resetCaloriesState())
        dispatch(resetNotesState())
        dispatch(resetMessagesState())
        dispatch(resetPatientContentState())
        dispatch(resetReportsByPatient())
        dispatch(resetScoresByPatient())

        break
      }
      default: break
    }

    return next(action)
  }
}